import { memo, useEffect } from "react";
import { useStore } from "../../store/globalState";
import { mockSelectedPayment } from "../../gallery/mockData";
import {
  applyFirstSendSeed,
  isFirstSendWarningVisible,
} from "../../gallery/firstSendMock";
import { useGalleryFirstSend } from "../../hooks/useGalleryFirstSend";
import type { FundingCategory } from "../../utils/sendCatalog";
import { paymentType } from "../../interfaces/payment";
import { FirstSendWarning } from "../first-send/FirstSendWarning";

const PAYMENT_TYPE_CATEGORY: Record<paymentType, FundingCategory> = {
  [paymentType.CARD]: "CARD",
  [paymentType.BANK]: "ACCOUNT",
  [paymentType.CASH]: "CASH",
  [paymentType.OTHER]: "OTHER",
};

interface M2mFirstSendWarningProps {
  sendAmount: number | null;
  sourceCurrency: string;
}

/** Shared by the three m2m Transfer flavors; renders nothing outside the variant. */
export const M2mFirstSendWarning = memo(
  ({ sendAmount, sourceCurrency }: M2mFirstSendWarningProps) => {
    const firstSend = useGalleryFirstSend();
    const { paymentState } = useStore();

    useEffect(() => {
      if (!firstSend) return;
      return applyFirstSendSeed({ payment: mockSelectedPayment });
    }, [firstSend]);

    if (!firstSend) return null;
    const visible = isFirstSendWarningVisible({
      sendAmount,
      sourceCurrency,
      fundingCategory: paymentState.payment
        ? PAYMENT_TYPE_CATEGORY[paymentState.payment.type]
        : null,
    });
    return visible ? <FirstSendWarning copy={firstSend} /> : null;
  },
);
